import React, { useCallback } from "react";

import {
  Paper,
  Popper,
  Divider,
  InputBase,
  IconButton,
  Autocomplete,
  CircularProgress,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

import {
  getFullName,
  isEmpty as isStringEmpty,
} from "../../../../utils/string";
import RecognitionSearchBarResult from "../RecognitionSearchBarResult";

export default function RecognitionSearchBar({
  isLoading,
  placeholder,
  results = [],
  onFilter = () => {},
  onResultClick = () => {},
}) {
  const RecognitionSearchBarPopper = useCallback((props) => {
    const anchorEl = document.getElementById("recognition-search-bar-wrapper");

    return (
      <Popper
        {...props}
        anchorEl={anchorEl}
        style={{ width: anchorEl.clientWidth }}
        placement="bottom"
        sx={{
          padding: 0,
        }}
      />
    );
  }, []);

  return (
    <div>
      <Autocomplete
        loading={isLoading}
        ListboxProps={{ style: { maxHeight: "250px" } }}
        freeSolo
        id="recognition-search-bar"
        options={results}
        getOptionLabel={(option) =>
          getFullName(
            option?.caregiver?.first_name,
            option?.caregiver?.last_name
          )
        }
        filterOptions={(options, state) => onFilter(options, state?.inputValue)}
        PopperComponent={RecognitionSearchBarPopper}
        renderOption={(params, option) => {
          return (
            <div key={option?.id}>
              <RecognitionSearchBarResult
                id={option?.id}
                name={getFullName(
                  option?.caregiver?.first_name,
                  option?.caregiver?.last_name
                )}
                job={
                  !isStringEmpty(option?.job?.job_title)
                    ? option?.job?.job_title
                    : "-"
                }
                location={
                  !isStringEmpty(option?.office_location)
                    ? option?.office_location
                    : "-"
                }
                onClick={onResultClick}
              />
              <Divider />
            </div>
          );
        }}
        renderInput={(params) => {
          const { InputLabelProps, InputProps, ...rest } = params;

          return (
            <Paper
              variant="outlined"
              component="form"
              sx={{
                p: "2px 4px",
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <IconButton sx={{ p: "10px" }} aria-label="menu">
                <SearchIcon />
              </IconButton>
              <InputBase
                {...params.InputProps}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    event.stopPropagation();
                    event.preventDefault();
                  }
                }}
                endAdornment={
                  <>
                    {isLoading ? (
                      <CircularProgress
                        color="inherit"
                        size={16}
                        sx={{ margin: "0 var(--spacing-2x)" }}
                      />
                    ) : null}
                  </>
                }
                {...rest}
                sx={{
                  width: "100%",
                }}
                placeholder={
                  isStringEmpty(placeholder)
                    ? "Search Employees..."
                    : `${placeholder}...`
                }
              />
            </Paper>
          );
        }}
      />
    </div>
  );
}
